import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, " Novo Perfil ", -1)
const _hoisted_2 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Nome Perfil", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Observação", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, " Salvar ", -1)
const _hoisted_10 = { class: "pt-3 pb-2 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.short_name) = $event)),
          class: "form-control",
          name: "short_name"
        }, null, 512), [
          [_vModelText, $setup.data.short_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.long_name) = $event)),
          class: "form-control",
          name: "long_name"
        }, null, 512), [
          [_vModelText, $setup.data.long_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.note) = $event)),
          class: "form-control",
          name: "note"
        }, null, 512), [
          [_vModelText, $setup.data.note]
        ])
      ]),
      _hoisted_9
    ], 32),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar",
        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ])
  ]))
}